import React, { useContext } from "react";
import comp from "../index";
import { ProductContext, CanvasContext } from "../../provider";

interface CanvasControlsProps {}

function CanvasControls({}: CanvasControlsProps): JSX.Element {
  const { activeObject } = useContext(CanvasContext);
  const { productType } = useContext(ProductContext);

  return (
    productType &&
    (productType == "only-image" ||
      productType == "text-logo" ||
      productType == "pop-art") && (
      <>
        <div className={`product-canvas__controls product-canvas__controls-bg`}>
          <div
            className={`d-flex justify-content-center ${
              activeObject ? "transform-origin-top" : "transform-origin-bottom"
            }`}
            style={
              activeObject
                ? { transform: "scaleY(0)", height: 0 }
                : { transform: "scaleY(1)" }
            }></div>

          <div
            className={`w-100 ${
              activeObject ? "transform-origin-top" : "transform-origin-bottom"
            }`}
            style={
              activeObject
                ? { transform: "scaleY(1)" }
                : { transform: "scaleY(0)", height: 0 }
            }>
            {activeObject &&
              (activeObject.type == "image" ||
                activeObject.customType == "image" ||
                (activeObject.type == "rect" && productType == "pop-art")) && (
                <comp.ImageCanvasTools_Prd />
              )}
          </div>
        </div>
      </>
    )
  );
}

export default CanvasControls;
